import React from 'react';
import {observer} from "mobx-react";
import {SaveGameButtonContainerBox} from "./save-game-button-container.box";
import {ComponentServicesPick} from "../../../../services/component-services-pick";
import {withServices} from "../../../../react-hooks/with-services";
import {SaveGameButtonTitleBox} from './boxes/save-game-button-title.box';
import {SvgSizeUnit} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface SaveGameButtonComponentWithServicesProps extends ComponentServicesPick<'games' | 'notifications' | 'theme'> {
    gameType: number;
    onBookGame: () => void;
    onRemoveBookedGame: () => void;
}

const ComponentBody :React.FC<SaveGameButtonComponentWithServicesProps> = observer((props) => {

    const [isSaved, setIsSaved] = React.useState(props.games.savedGameTypes.indexOf(props.gameType) >= 0);

    const toggleSaveGame = (): void => {
        if (isSaved) {
            props.games.removeSavedGame(props.gameType);
            props.onRemoveBookedGame();
        } else {
            props.games.saveGame(props.gameType);
            props.notifications.showGameSavedNotification();
            props.onBookGame();
        }

        setIsSaved((wasSaved) => !wasSaved);
    };

    const SavedGamesIcon = props.theme.currentTheme.icons.saveGameIcon;

    const getCyClass = () => `cy-save-game-button-${isSaved ? 'filled' : 'empty'}`;

    return (
        <SaveGameButtonContainerBox onClick={toggleSaveGame} className={getCyClass()}>
                <SavedGamesIcon shouldFill={isSaved} sizeUnit={SvgSizeUnit.Px} size={22} />
                <SaveGameButtonTitleBox>
                    {props.games.generateTimesSavedCounterForGame(props.gameType) + Number(isSaved)}
                </SaveGameButtonTitleBox>
        </SaveGameButtonContainerBox>
    );
});

export const SaveGameButtonComponent = withServices(ComponentBody, ["games", 'notifications', "theme"]);

